import gsap from 'imports/gsap'
import browser from 'imports/browser-detect'
import stickCommon from 'site/stickCommon'
//import AOS from 'imports/aos'
let site = {
    browser: browser(),
    containerSel: null,
    bodySel: null,
    windowSel: null,
    rotateHolderSel: null,
    init: function () {
        site.containerSel = $('#container')
        site.slideshowSel = $('.simple-slideshow-hook')
        site.bodySel = $('body')
        site.windowSel = $(window)
        site.rotateHolderSel = $('#rotate-holder')

        //add browser name
        if (site.browser && site.browser.name) {
            site.bodySel.addClass("browser-" + site.browser.name)
        }

        //mobile stuff
        $('.ui-link').removeClass('ui-link')

        //disable img drag
        $('img').on('dragstart', function (event) {
            event.preventDefault()
        })
        if (site.browser && site.browser.mobile) {
            site.bodySel.addClass("device-mobile")
        } else {
            site.bodySel.addClass("device-notmobile")
        }

        //analytics
        stickCommon.scAddAnalyticsEventHandle('body')

        //orientation change
        site.windowSel.on("orientationchange", function () {
            site.siteOrientationChange()
        })
        site.siteOrientationChange()
        site.windowSel.on("resize", site.siteResize)

        // final
        window.dispatchEvent(new Event('resize'))

        site.containerSel.css('opacity', 1)

        // fullscreen open and close
        $('.fullscreen-open').on("click", site.fullscreenOpenClick)
        $('.fullscreen-close').on("click", site.fullscreenCloseClick)
        const isFullscreenSupported = site.isFullscreenSupported()
        if (isFullscreenSupported !== true) {
            $('body').addClass('fullscreen-notsupported')
        }
        $(document).on('fullscreenchange webkitfullscreenchange mozfullscreenchange MSFullscreenChange', function() {
            if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
                // console.log('Entered fullscreen mode');
                $('body').addClass('fullscreen-yes')
            } else {
                // console.log('Exited fullscreen mode');
                $('body').removeClass('fullscreen-yes')
            }
        });
    },
    siteOrientationChange() {
        setTimeout(function () {
            let isPortrait = true
            if (site.bodySel.hasClass('device-notmobile')) {
                isPortrait = true
            } else {
                isPortrait = (site.windowSel.width() < site.windowSel.height())
            }

            if (site.bodySel.hasClass('device-notmobile')) {
                site.rotateHolderSel.hide()
            } else {
                if (!isPortrait) {
                    site.rotateHolderSel.hide()
                } else {
                    site.rotateHolderSel.show()
                }
            }

            //if( (window.orientation === 90 && $( window ).width() < 780) || (window.orientation === -90 && $( window ).width() < 780) ) // Landscape {
        }, 100)
    },
    siteResize: function () {
        // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`)

        site.siteOrientationChange()

        let sh = site.windowSel.height()
        let sw = site.windowSel.width()
        let ogRat = 1369 / 938

        //sidebar + margin 200 + 50 sidebar margin + 50 on each side
        let sidebarPadding = 50
        let topBottomPadding = 40
        let rat = 2738 / 938 //desktop (2x1)
        if (sw < window.mobileBreakpoint) {
            sidebarPadding = 20
            topBottomPadding = 200
            rat =  ogRat
        }
        if (site.bodySel.hasClass('device-mobile')) {
            sidebarPadding = 20
            topBottomPadding = 0
            rat =  ogRat
        }

        //maintain  ratio in site.containerSel
        let newH = sh - topBottomPadding
        let newW = newH * rat
        let theY = 0
        if (newW > sw - sidebarPadding) {
            newW = sw - sidebarPadding
            newH = newW / rat
        }
        if (sw < window.mobileBreakpoint) {
            theY =  0;
        }


        //set ratio calculator
        let newRat = newW / 938
        document.documentElement.style.setProperty('--newRat', `${newRat}`)

        site.containerSel.css({
            width: newW,
            height: 'auto',
            top: theY
        })
        site.slideshowSel.css({
            width: newW,
            height: newH,
            //top: theY
        })

        let widthLeft = (sw - newW)/2
        let offset = widthLeft/2
        $('#btn-devicemob-prev').css({
            left: offset - 16,
        })
        $('#btn-devicemob-next').css({
            right: offset - 16,
        })
        $('#btn-devicemob-fullscreen-open').css({
            right: offset - 16,
        })
        $('#btn-devicemob-fullscreen-close').css({
            right: offset - 16,
        })
    },

    fullscreenOpenClick () {
        if (!document.fullscreenElement &&    // alternative standard method
            !document.mozFullScreenElement && !document.webkitFullscreenElement) {  // current working methods
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen();
            } else if (document.documentElement.mozRequestFullScreen) { /* Firefox */
                document.documentElement.mozRequestFullScreen();
            } else if (document.documentElement.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
                document.documentElement.webkitRequestFullscreen();
            }
        }
    },
    fullscreenCloseClick () {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.mozCancelFullScreen) { /* Firefox */
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
            document.webkitExitFullscreen();
        }
    },
    isFullscreenSupported() {
        console.log('document', document)
        return document.fullscreenEnabled ||
        document.webkitFullscreenEnabled ||
        document.mozFullScreenEnabled ||
        document.msFullscreenEnabled;
    }
}
export default site
